import type { SpeakerScore } from '../lib/types';
import { ScorePill } from './ScorePill';
import { formatScore } from '../lib/format';
import { verdictFromScore } from '../lib/verdict';
import styles from './SpeakerSentimentPanel.module.css';

interface Props {
  speakers: SpeakerScore[];
  className?: string;
}

export function SpeakerSentimentPanel({ speakers, className }: Props) {
  return (
    <ul className={[styles.list, className].filter(Boolean).join(' ')}>
      {speakers.map((s) => {
        const v = verdictFromScore(s.score);
        const deltaClass = s.delta == null ? '' : s.delta > 0 ? styles.deltaUp : s.delta < 0 ? styles.deltaDown : styles.deltaFlat;
        return (
          <li key={s.name} className={styles.row}>
            <div className={styles.head}>
              <div className={styles.identity}>
                <span className={styles.role}>{s.role}</span>
                <span className={styles.name}>{s.name}</span>
              </div>
              <div className={styles.scoreWrap}>
                <ScorePill verdict={v} score={s.score} size="sm" />
                {s.delta != null && (
                  <span className={[styles.delta, deltaClass, 'mono'].join(' ')}>
                    {s.delta > 0 ? '▲' : s.delta < 0 ? '▼' : '·'} {formatScore(s.delta)}
                  </span>
                )}
              </div>
            </div>
            <div className={styles.metrics}>
              <span className={styles.metric}>
                <span className={styles.metricLabel}>Hedge density</span>
                <span className={[styles.metricValue, 'mono'].join(' ')}>{(s.hedgeDensity * 100).toFixed(0)}%</span>
              </span>
              <span className={styles.metric}>
                <span className={styles.metricLabel}>Forward modals</span>
                <span className={[styles.metricValue, 'mono'].join(' ')}>{(s.forwardModalDensity * 100).toFixed(0)}%</span>
              </span>
              <span className={styles.metric}>
                <span className={styles.metricLabel}>Utterances</span>
                <span className={[styles.metricValue, 'mono'].join(' ')}>{s.utterances}</span>
              </span>
              <span className={styles.metric}>
                <span className={styles.metricLabel}>Confidence</span>
                <span className={styles.metricValue} style={{ color: scoreColor(s.score) }}>{s.qualifier}</span>
              </span>
            </div>
            {s.highlight && <p className={styles.highlight}>{s.highlight}</p>}
          </li>
        );
      })}
    </ul>
  );
}

function scoreColor(score: number) {
  if (score >= 0.5) return 'var(--tia-positive)';
  if (score >= 0.25) return 'var(--tia-positive)';
  if (score <= -0.25) return 'var(--tia-negative)';
  return 'var(--tia-warning)';
}
